import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "utilization-pricing-settings" }
const _hoisted_2 = {
  key: 0,
  class: "loading-spinner"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "table table-striped" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_8 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_9 = { class: "price-unit-container" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "button-group" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "day-tabs"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "table table-striped" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_21 = ["onUpdate:modelValue", "onBlur"]
const _hoisted_22 = { class: "price-unit-container" }
const _hoisted_23 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "button-group" }
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PriceUnitComponent = _resolveComponent("PriceUnitComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.isAllWeek)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("table", _hoisted_5, [
                    _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Utilization %"),
                        _createElementVNode("th", null, "Price"),
                        _createElementVNode("th", null, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.utilizationDay?.timeWindows[0]
                  .utilizationRanges, (range, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: range.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_6, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((range.low) = $event),
                                type: "number",
                                min: "0",
                                max: "100",
                                class: _normalizeClass({
                        'form-control': true,
                        'form-control-error': _ctx.invalidRange(true, range, index, _ctx.utilizationDay!),
                      }),
                                onBlur: ($event: any) => (_ctx.checkRange(true, range, index, _ctx.utilizationDay!))
                              }, null, 42, _hoisted_7), [
                                [
                                  _vModelText,
                                  range.low,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "input-group-text" }, "-", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((range.high) = $event),
                                type: "number",
                                min: "0",
                                max: "100",
                                class: _normalizeClass({
                        'form-control': true,
                        'form-control-error': _ctx.invalidRange(false, range, index, _ctx.utilizationDay!),
                      }),
                                onBlur: ($event: any) => (_ctx.checkRange(false, range, index, _ctx.utilizationDay!))
                              }, null, 42, _hoisted_8), [
                                [
                                  _vModelText,
                                  range.high,
                                  void 0,
                                  { number: true }
                                ]
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_PriceUnitComponent, {
                                class: "price-unit",
                                value: _ctx.getPriceValue(range),
                                isPercent: range.usePercent,
                                "onUpdate:value": ($event: any) => (_ctx.updatePriceValue(range, $event)),
                                "onUpdate:isPercent": ($event: any) => (_ctx.updateUsePercent(range, $event))
                              }, null, 8, ["value", "isPercent", "onUpdate:value", "onUpdate:isPercent"]),
                              (range.usePercent)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_10, " (" + _toDisplayString(`${Math.abs(
                          _ctx.calculatePercentageOff(range.pricePercentage)
                        )} % ${
                          _ctx.calculatePercentageOff(range.pricePercentage) >= 0
                            ? 'off'
                            : 'increase'
                        } `) + ") ", 1))
                                : (_openBlock(), _createElementBlock("small", _hoisted_11, " (fixed price) "))
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.deleteRange(_ctx.utilizationDay!, index)),
                              class: "btn btn-danger btn-sm"
                            }, [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("i", { class: "fa fa-trash-o" }, null, -1)
                            ]))], 8, _hoisted_12)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addRange(_ctx.utilizationDay!)), ["prevent"])),
                      class: "btn btn-primary"
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                      _createTextVNode(" Add Row ", -1)
                    ]))])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!_ctx.isAllDay)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: day.value,
                          class: _normalizeClass([{ active: _ctx.activeDay === day.value }, "btn btn-secondary"]),
                          onClick: ($event: any) => {
              {
                _ctx.handleActiveDayChange(day.value);
              }
            }
                        }, _toDisplayString(day.label), 11, _hoisted_16))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.utilizationData, (dailyUtilization) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: dailyUtilization.dayOfWeek
                  }, [
                    (_ctx.isAllDay || dailyUtilization.dayOfWeek === _ctx.activeDay)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("table", _hoisted_18, [
                            _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Utilization %"),
                                _createElementVNode("th", null, "Price"),
                                _createElementVNode("th", null, "Actions")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyUtilization.timeWindows[0]
                    .utilizationRanges, (range, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: range.id
                                }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_19, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((range.low) = $event),
                                        type: "number",
                                        min: "0",
                                        max: "100",
                                        class: _normalizeClass({
                          'form-control': true,
                          'form-control-error': _ctx.invalidRange(true, range, index, _ctx.utilizationDay!),
                         }),
                                        onBlur: ($event: any) => (_ctx.checkRange(true, range, index, _ctx.utilizationDay!))
                                      }, null, 42, _hoisted_20), [
                                        [
                                          _vModelText,
                                          range.low,
                                          void 0,
                                          { number: true }
                                        ]
                                      ]),
                                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "input-group-text" }, "-", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": ($event: any) => ((range.high) = $event),
                                        type: "number",
                                        min: "0",
                                        max: "100",
                                        class: _normalizeClass({
                          'form-control': true,
                          'form-control-error': _ctx.invalidRange(false, range, index, _ctx.utilizationDay!),
                        }),
                                        onBlur: ($event: any) => (_ctx.checkRange(false, range, index, _ctx.utilizationDay!))
                                      }, null, 42, _hoisted_21), [
                                        [
                                          _vModelText,
                                          range.high,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_PriceUnitComponent, {
                                        class: "price-unit",
                                        value: _ctx.getPriceValue(range),
                                        isPercent: range.usePercent,
                                        "onUpdate:value": ($event: any) => (_ctx.updatePriceValue(range, $event)),
                                        "onUpdate:isPercent": ($event: any) => (_ctx.updateUsePercent(range, $event))
                                      }, null, 8, ["value", "isPercent", "onUpdate:value", "onUpdate:isPercent"]),
                                      (range.usePercent)
                                        ? (_openBlock(), _createElementBlock("small", _hoisted_23, " (" + _toDisplayString(`${Math.abs(
                            _ctx.calculatePercentageOff(range.pricePercentage)
                          )} % ${
                            _ctx.calculatePercentageOff(range.pricePercentage) >= 0
                              ? 'off'
                              : 'increase'
                          } `) + ") ", 1))
                                        : (_openBlock(), _createElementBlock("small", _hoisted_24, " (fixed price) "))
                                    ])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      onClick: ($event: any) => (_ctx.deleteRange(dailyUtilization, index)),
                                      class: "btn btn-danger btn-sm"
                                    }, [...(_cache[6] || (_cache[6] = [
                                      _createElementVNode("i", { class: "fa fa-trash-o" }, null, -1)
                                    ]))], 8, _hoisted_25)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            (!_ctx.isDisabled)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: _withModifiers(($event: any) => (_ctx.addRange(dailyUtilization)), ["prevent"]),
                                  class: "btn btn-primary"
                                }, [...(_cache[8] || (_cache[8] = [
                                  _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                                  _createTextVNode(" Add Row ", -1)
                                ]))], 8, _hoisted_27))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
        ]))
  ]))
}